import { Vue } from 'ui.vue';
import { } from 'germes.bonus';
import 'style.css';
Vue.component('vue-cart-bonus-selector', {
	name: 'contragent.bonus.selector',
	data() {
		return {
			error: null,
			bonus: [],
		}
	},
	props: {
		params: {
			type: Object,
			default: () => {
				return {};
			}
		},
	},
	computed: {
		localize() {
			return Vue.getFilteredPhrases("");
		},
		componentError: {
			get() {
				return this.error;
			},
			set(errorText) {
				if (this.error !== errorText) {
					this.$root.$emit('componentError', { id: this.$options.name, text: errorText });
					this.error = errorText;
					if (this.error) {
						if (BX.UI?.Notification?.Center) {
							BX?.UI?.Notification?.Center?.notify({
								content: this.error,
								position: "bottom-right",
								autoHide: true,
								autoHideDelay: 2000,
								closeButton: true,
								category: "bonus-list-alert",
							});
						} else {
							console.error(this.error);
						}
					}
				}
			}
		},
		bonusType: {
			get() {
				this.checkBonusPossibility();
				return this.$store.getters['bonus/getSaleType'];
			},
			set(value) {
				this.$store.commit('bonus/setSaleType', value);
			}
		},
		basket: (state) => {
			return state.$store.getters['basket/basket'];
		},
		cartCurrency: (state) => {
			return state.$store.getters['basket/getCurrency'];
		},
		contragent: (state) => {
			return state.$store.getters['basket/getContragent'];
		},
		basketBasePrice: (state) => {
			return state.$store.getters['basket/getBasketBasePrice'];
		},
		bonusPrograms: (state) => {
			return state.$store.getters['bonus/getBonusPrograms'];
		},
		bonusProgram: (state) => {
			for (const i in state.bonusPrograms) {
				if (Object.hasOwnProperty.call(state.bonusPrograms, i) && state.bonusPrograms[i].CODE == state.bonusType) {
					return state.bonusPrograms[i];
				}
			}
		},
		basketPriceDiscount: (state) => {
			return state.getMaxBonusCart?.PRICE;
		},
		basketPriceDiscountCurrency: (state) => {
			return BX?.Currency?.currencyFormat(state.basketPriceDiscount, state.cartCurrency, false).replace(/&nbsp;/g, ' ');
		},
		bonusPrice: (state) => {
			return state.spentBonusValue;
		},
		spentBonusPrice: (state) => {
			return state.getMaxBonusCart.PRICE;
		},
		spentBonusValue: (state) => {
			return state.getMaxBonusCart.VALUE;
		},

		getMaxBonusCart: (state) => {
			let totalPrice = state.$store.getters['basket/getBasketPriceAvailable'];
			let bonusList = state.bonus;
			let bonusListUsed = [];
			let spentBonusPrice = 0;
			let spentBonusValue = 0;
			if (typeof bonusList == 'object' && Object.keys(bonusList).length && totalPrice > 0) {
				let totalPrice_copy = totalPrice;
				let $maxSale = totalPrice_copy * 0.2;
				let $totalSale = 0;
				let $totalValue = 0;
				for (const i in bonusList) {
					if (Object.hasOwnProperty.call(bonusList, i)) {
						let $bonus = bonusList[i];
						// $bonus['MAX_VALUE'] = $bonus['MAX_VALUE']?:1;
						// $maxBonusPrice = totalPrice * $bonus['MAX_VALUE'] / 100;

						// Определили стоимость бонуса
						$bonus.VALUE_CONVERTED = $bonus.VALUE * $bonus.CURS;
						$bonus.PRICE_SPENT = $bonus.VALUE * $bonus.CURS;
						if ($bonus.PRICE_SPENT > $maxSale) {
							$bonus.PRICE_SPENT = $maxSale;
						} else if ($bonus.PRICE_SPENT <= $maxSale) {
							//
						}

						// Определили бонусы
						$bonus.SPENT_IN_PERCENT = $bonus.PRICE_SPENT * 100 / $bonus.VALUE_CONVERTED; // процент потраченного
						$bonus.LEFT_IN_PERCENT = 100 - $bonus.SPENT_IN_PERCENT;
						$bonus.LEFT_VALUE = ($bonus.VALUE_CONVERTED - $bonus.PRICE_SPENT) / $bonus.CURS;
						$bonus.SPENT_VALUE = $bonus.LEFT_VALUE ? $bonus.VALUE - $bonus.LEFT_VALUE : $bonus.VALUE;

						bonusListUsed.push($bonus);
						totalPrice_copy -= parseFloat($bonus.PRICE_SPENT);
						if (totalPrice_copy <= 0) {
							break;
						}
						$maxSale -= parseFloat($bonus.PRICE_SPENT);
						$totalValue += parseFloat($bonus.SPENT_VALUE);
						$totalSale += parseFloat($bonus.PRICE_SPENT);
						if (!$maxSale) {
							break;
						}
					}
				}
				spentBonusPrice = parseFloat($totalSale).toFixed(2);
				spentBonusValue = parseInt($totalValue);
			}
			return {
				PRICE: spentBonusPrice,
				VALUE: spentBonusValue
			}
		},

		maxBonusCountedPrice: (state) => {
			return state.getMaxBonusCart.PRICE;
		},
		maxBonusCountedPriceCurrency: (state) => {
			return BX?.Currency?.currencyFormat(state.maxBonusCountedPrice, state.cartCurrency, false).replace(/&nbsp;/g, ' ');
		},
		maxBonusCountedValue: (state) => {
			return state.getMaxBonusCart.VALUE;
		},
		maxBonusCountedValueCurrency: (state) => {
			return BX?.Currency?.currencyFormat(state.maxBonusCountedValue, state.cartCurrency, false).replace(/&nbsp;/g, ' ');
		},
		totalBonusValue: (state) => {
			return state.bonus?.reduce((acc, bonus) => {
				const value = parseFloat(bonus.VALUE);
				const bonusDate = new Date(bonus.TIMESTAMP * 1000);
				const curDate = new Date();
				if (!isNaN(value) && bonusDate >= curDate) {
					acc += value;
				}
				return acc;
			}, 0);
		},
		totalBonusValueCurrency: (state) => {
			return BX?.Currency?.currencyFormat(state.totalBonusValue, state.cartCurrency, false).replace(/&nbsp;/g, ' ');
		},
		totalBonusValueInCurs: (state) => {
			return state.bonus?.reduce((acc, bonus) => {
				const value = parseFloat(bonus.VALUE);
				const curs = parseFloat(bonus.CURS);
				const bonusDate = new Date(bonus.TIMESTAMP * 1000);
				const curDate = new Date();
				if (!isNaN(value) && !isNaN(curs) && bonusDate >= curDate) {
					acc += value * curs;
				}
				return acc;
			}, 0);
		},
		totalBonusValueInCurrency: (state) => {
			return BX?.Currency?.currencyFormat(state.totalBonusValueInCurs, state.cartCurrency, false).replace(/&nbsp;/g, ' ');
		},
		basketBasePriceTitle: (state) => {
			return state.localize.USE_BONUS_TITLE
				?.replace('#MAX_BONUS#', state.totalBonusValueCurrency)
				?.replace('#MAX_BONUS_PRICE#', state.totalBonusValueInCurrency)
		},
		bonusTypeTitle: (state) => {
			return (state.bonusProgram?.DESCRIPTION || state.localize.VUE_BONUS_ACCEPTED)
				?.replace('#SUM#', state.spentBonusValue)
		}
	},
	created() {
		document.addEventListener('DOMContentLoaded', () => {
			this.requestContragentBonus();
		});
		BX.addCustomEvent("OnAfterContragentChange", BX.delegate((event) => {
			this.bonusType = this.bonusPrograms[0]?.CODE;
			this.requestContragentBonus();
		}, this));
	},
	methods: {
		setBonus: function (bonusList) {
			this.bonus = [...this.bonus, ...bonusList];
		},
		clearBonus: function () {
			this.bonus.length = 0;
		},
		requestContragentBonus: function () {
			if (this.contragent?.ID == undefined) return;
			const key = 'BonusList-' + this.activeContragentId;
			try {
				const localBonus = JSON.parse(sessionStorage.getItem(key));
				if (localBonus && localBonus.time >= Date.now() && localBonus.list?.length) {
					this.setBonus(localBonus.list);
				}
			} catch (error) {
				console.error(error);
			}
			if (!this.bonus?.length) {
				const fetchKey = 'fetch' + key;
				if (!window[fetchKey]) {
					window[fetchKey] = BX.ajax.runAction('germes:multibasket.bonus.getList', {
						data: {
							contragentId: this.contragent.ID
						}
					});
				}
				window[fetchKey].then(response => {
					if (response.errors?.length) throw response;
					this.setBonus(response.data);
					const val = JSON.stringify({
						time: Date.now() + 10 * 60 * 1000, // 10 минут
						list: this.bonusList
					});
					sessionStorage?.setItem(key, val);
					return response;
				}).catch(response => {
					console.error(response);
					this.clearBonus();
					return response;
				}).then(response => {
					delete (window[fetchKey]);
					return response;
				});
			}
		},
		checkBonusPossibility: function () {
			let error = null;
			if (this.$store.getters['bonus/getSaleType'] != this.bonusPrograms[0].CODE && this.basketPriceDiscount > this.maxBonusCountedPrice) {
				error = this.localize?.VUE_BONUS_POSSIBILITY_ERROR
					?.replace("#BONUS_MAX_SUMM#", this.maxBonusCountedPriceCurrency)
					?.replace("#BASKET_DISCOUNT_SUMM#", this.basketPriceDiscountCurrency)
			}
			this.componentError = error;
		}
	},
	template: `
        <div v-if="totalBonusValue" class="row cart-bonus-selector">
            <div class="col-auto pr-2">
                <i class="wow pulse fas fa-gift" :title="'Доступно ' +(totalBonusValueInCurrency)+ ' бонусов.'"></i>
            </div>
            <div class="col pl-0 bonus-total-title">
                <div v-if="basketBasePrice" v-html="basketBasePriceTitle"></div>
                <div v-else>{{localize.NO_BONUS_PROGRAM_FOR_EMPTY_CART}}</div>
            </div>
            <div class="col-12" v-if="basketBasePrice && totalBonusValue > 0 && bonusPrograms">
                <label v-for="bonusProgram in bonusPrograms"
                    :for="bonusProgram.CODE"
                    class="bonus-label-btn"
                    :class="{
                        'checked-bonus': (bonusType == bonusProgram.CODE),
                        'text-success border-success': (basketPriceDiscount <= maxBonusCountedPrice && bonusType == bonusProgram.CODE),
                        'text-danger border-danger alert-danger': (basketPriceDiscount > maxBonusCountedPrice && bonusType == bonusProgram.CODE)
                    }"
                    :data-id="bonusProgram.ID"
                    :data-sort="bonusProgram.SORT"
                    :data-sum="bonusPrice"
                    :title="bonusProgram.NAME"
                    >
                    <input type="radio"
                        name="BONUS_PROGRAM[TYPE]"
                        :id="bonusProgram.CODE"
                        :value="bonusProgram.CODE"
                        :title="bonusProgram.DESCRIPTION"
                        v-model="bonusType" />
                    &nbsp;
                    <span v-if="bonusProgram.IMAGE" v-html="bonusProgram.IMAGE"></span>
                    <span v-if="bonusType != bonusProgram.CODE">
                        {{(bonusProgram.NAME || localize.USE_BONUS_BUY_GENERAL)}}
                    </span>
                    <span v-else-if="bonusType == bonusProgram.CODE" class="pr-3" :title="localize.ADVANCE_BONUS_PAYNEMT_SUM">
                        {{bonusTypeTitle}}
                        <span v-if="bonusType != 'NO_BONUS_PROGRAM'" style="white-space: nowrap;">
                            (<b v-html="basketPriceDiscountCurrency"></b>)
                            <b v-if="basketPriceDiscount > maxBonusCountedPrice">(max {{maxBonusCountedPriceCurrency}})</b>
                        </span>
                        <input type="hidden" name="BONUS_PROGRAM[PRICE]" :value="spentBonusPrice"/>
                        <input type="hidden" name="BONUS_PROGRAM[VALUE]" :value="spentBonusValue"/>
                    </span>
                    <span v-if="bonusProgram.HELP" class="help far fa-question-circle ml-auto" :title="bonusProgram.HELP"></span>
                </label>
            </div>
            <div v-else-if="basketBasePrice" class="col-12"><span class="bonus-label-btn alert alert-info">{{localize.VUE_BONUS_NO_PROGRAM_AVAILABLE}}</span></div>
        </div>
    `
});
